// components/MapController.js
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

const MapController = ({
  currentLocation,
  ciudadSeleccionada,
  provinciaSeleccionada,
}) => {
  const map = useMap();

  // Fetch dinámico a la API Georef
  useEffect(() => {
    const fetchCoords = async () => {
      if (!ciudadSeleccionada && !provinciaSeleccionada) return;

      const baseUrl = "https://apis.datos.gob.ar/georef/api/";
      const url = ciudadSeleccionada
        ? `${baseUrl}localidades?nombre=${encodeURIComponent(
            ciudadSeleccionada
          )}&campos=centroide&max=1`
        : `${baseUrl}provincias?nombre=${encodeURIComponent(
            provinciaSeleccionada
          )}&campos=centroide&max=1`;

      try {
        const res = await fetch(url);
        const data = await res.json();

        const coords = ciudadSeleccionada
          ? data.localidades?.[0]?.centroide
          : data.provincias?.[0]?.centroide;

        if (coords && map) {
          const { lat, lon } = coords;
          const newCenter = { lat: lat, lng: lon };
          map.setCenter(newCenter);
          provinciaSeleccionada ? map.setZoom(7) : map.setZoom(13);
        }
      } catch (err) {
        console.error("Error obteniendo coordenadas desde Georef:", err);
      }
    };

    fetchCoords();
  }, [ciudadSeleccionada, provinciaSeleccionada, map]);

  // Mantener pan a ubicación actual si hay
  useEffect(() => {
    if (map && currentLocation) {
      map.panTo(currentLocation);
    }
  }, [currentLocation, map]);

  return null;
};

export default MapController;
